
import * as angular from "angular";

export function RLIndeterminate() {
    var directive: ng.IDirective = {
        restrict: "A",
        priority: 1000,
        compile: (tElement: ng.IAugmentedJQuery, tAttrs: ng.IAttributes) => {

            if (!tAttrs["type"] || tAttrs["type"].toLowerCase() !== 'checkbox') {
                return angular.noop;
            }

            return (scope: ng.IScope, formElement: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
                scope.$watch(() => attributes["rl-indeterminate"],
                    (newValue, oldValue) => {
                        formElement[0]["indeterminate"] = !!newValue;
                    });
            };
        }
    };
    return directive;
}
